import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=bbf82812&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=bbf82812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf82812",
  null
  
)

export default component.exports